// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyALAzxvL0dtH8svzV5C7RsMtqw-F0O3fw0",
  authDomain: "wastemanagementseo16.firebaseapp.com",
  projectId: "wastemanagementseo16",
  storageBucket: "wastemanagementseo16.firebasestorage.app",
  messagingSenderId: "64692399729",
  appId: "1:64692399729:web:e8238ebfa65e5de1aa75d0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;